import './App.css';
import React from "react";
import { Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.min.css';

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'

import Layout from './pages/Layout';
import Err404 from './pages/Err404';
import Login from './pages/Login'
import Logout from './pages/Logout'

import Overview from './pages/Overview'
import MapView from './pages/MapView';
import Sensors from './pages/Sensors';
import Settings from './pages/Settings';
import Alerts from './pages/Alerts';
import Trends from './pages/Trends';

import AdminTaskSchedule from './pages/AdminTaskSchedule';
import AdminViewData from './pages/AdminViewData';
import AdminViewDevice from './pages/AdminViewDevice';
import AdminViewDeviceHealth from './pages/AdminViewDeviceHealth';

import Register from './pages/Register'
import ResetPassword from './pages/ResetPassword'

import ProtectedRoute from "./components/ProtectedRoute";
import { UserAuthContextProvider } from "./context/UserAuthContext";


function App() {


  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale="en-gb">

       <UserAuthContextProvider>
        <Routes>
          <Route path="/" index element={<Login />} />
          <Route path="Login" index element={<Login />} />
          <Route path="izeem-admin/AdminTaskSchedule" element={<AdminTaskSchedule />} />
          <Route path="izeem-admin/AdminViewData" element={<AdminViewData />} />
          <Route path="izeem-admin/AdminViewDevice" element={<AdminViewDevice />} />
          <Route path="izeem-admin/AdminViewDeviceHealth" element={<AdminViewDeviceHealth />} />
          <Route path="izeem-admin/register" element={<Register />} />
          <Route path="reset_password" element={<ResetPassword />} />
          <Route path="Logout" element={<Logout />} />
          <Route path="*" element={<Err404 />} />

          <Route element={<Layout id="Overview" />}>
            <Route path="Overview"
              element={
                <ProtectedRoute>
                    <Overview />
                </ProtectedRoute>
              } />
          </Route>

          <Route element={<Layout id="MapView" />}>
          <Route path="MapView"
              element={
                <ProtectedRoute>
                    <MapView />
                </ProtectedRoute>
              } />
          </Route>

          <Route element={<Layout id="Sensors" />}>
          <Route path="Sensors"
              element={
                  <ProtectedRoute>
                    <Sensors />
                </ProtectedRoute>
              } />
          </Route>

          <Route element={<Layout id="Alerts" />}>
          <Route path="Alerts"
              element={
                <ProtectedRoute>
                    <Alerts />
                </ProtectedRoute>
              } />
          </Route>
          
          <Route element={<Layout id="Trends" />}>
          <Route path="Trends"
              element={
                <ProtectedRoute>
                    <Trends />
                </ProtectedRoute>
              } />
          </Route>

          <Route element={<Layout id="Settings" />}>
          <Route path="Settings"
              element={
                  <ProtectedRoute>
                      <Settings />
                    </ProtectedRoute>
              } />
          </Route>
        </Routes>
       </UserAuthContextProvider>
    </LocalizationProvider> 


  );
}

export default App;
